import React from "react";
import "./PopeyeNewsCard.scss";
import { getIcon, getFlag } from '../../../../utils/images';
import { Tooltip } from 'antd';

const PopeyeNewsCard = ({newsItem}) => {
  
  return (
    <div className="PopeyeNewsCard">
      <div className="news-details">
        <div className="news-item">
          <Tooltip title={newsItem.shipping_line?.name}>
            <div className="news-logo">
              <img src={newsItem.image || getIcon('logo-mini')} alt="logo" />
            </div>
          </Tooltip>          
        </div>
      </div>
      <div className="content-message">
        <p>{newsItem.title}</p>
      </div>
    </div>
  );
}

export default PopeyeNewsCard;
